import React, { useState, useEffect, useContext } from 'react';
import {
  IonButton,
  IonMenu,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonList,
  IonMenuToggle,
  IonItem,
  IonLabel,
  IonGrid,
  IonRow,
  IonCol,
  IonSlides,
  IonSlide,
  IonImg,
} from '@ionic/react';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

export const HomeButton = () => {
  return (
    <IonButton class="homeToolbarButtons" routerLink="/home">
      Home
    </IonButton>
  );
};

export const Menu = ({ disabled }) => {
  return (
    <IonMenu contentId="qavaAppConfirmed" disabled={disabled} side="end">
      <IonHeader>
        <IonToolbar>
          <IonTitle>Menu</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          <IonMenuToggle auto-hide="false">
            <IonItem button routerLink="/merchantMainPageApp">
              <IonLabel>Home</IonLabel>
            </IonItem>
          </IonMenuToggle>
          <IonMenuToggle auto-hide="false">
            <IonItem button routerLink="/profileSetting">
              <IonLabel>Profile</IonLabel>
            </IonItem>
          </IonMenuToggle>
          <IonMenuToggle auto-hide="false">
            <IonItem button routerLink="/accountSetting">
              <IonLabel>Account</IonLabel>
            </IonItem>
          </IonMenuToggle>
          <IonMenuToggle auto-hide="false">
            <IonItem button routerLink="/logout">
              <IonLabel>Logout</IonLabel>
            </IonItem>
          </IonMenuToggle>
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export const UploadedInvoiceTemplates = ({ accountID, schemaName }) => {
  const { sessionID, baseURL } = useContext(Auth_MerchantID_context);
  const [items, setItems] = useState([]);
  const [downloadComplete, setDownloadComplete] = useState(false);

  const getData = async () => {
    const requestOptions = {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        Tracker: 72004,
        user: accountID,
        sessionID: sessionID,
      }),
    };

    const response = await fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions);
    const result = await response.text();

    const rows = result.toString().split('~~~');
    const newItems = rows.slice(0, -1).map((row) => {
      const cols = row.split('|');
      return {
        imageID: cols[0],
        originalImage: cols[1],
        postscriptImage: cols[2],
        imgHeight: Math.floor(Math.random() * 50 + 150),
      };
    });

    setItems(newItems);
    setDownloadComplete(true);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <IonGrid>
      <IonRow>
        <IonCol>
          <IonSlides>
            {items.map((item) => (
              <IonSlide key={item.imageID}>
                <IonGrid>
                  <IonRow>
                    <IonCol>
                      <h1>{item.imageID}</h1>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol>
                      <IonImg src={item.originalImage}></IonImg>
                    </IonCol>
                    <IonCol>
                      <IonImg src={item.postscriptImage}></IonImg>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol>
                      <IonButton>Request Form</IonButton>
                      <IonButton>Actions</IonButton>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonSlide>
            ))}
          </IonSlides>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};